import { IUpdateItensServicoEmpreendimentoByConsultaUseCase } from "../../../presentation/useCases/update/update_itens_servico_empreendimento_by_consulta_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * updateItensServicoEmpreendimentoByConsultaUseCaseUseCase
 */

export class UpdateItensServicoEmpreendimentoByConsultaUseCase
  implements IUpdateItensServicoEmpreendimentoByConsultaUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async execute(
    idChecklistServicoEmpreendimento: number,
    quantidade?: number,
    valorUnitario?: number,
  ): Promise<void> {
    await this.repository.updateItensServicoEmpreendimentoByConsulta(idChecklistServicoEmpreendimento, quantidade, valorUnitario);
  }
}
